import _toConsumableArray from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import { FORCE_ORDERED_MENU_ITEMS } from "../../consts";
export var orderPinToTopMenuItems = function orderPinToTopMenuItems(items) {
  return _toConsumableArray(items).sort(function (a) {
    return FORCE_ORDERED_MENU_ITEMS.includes(a.slug) ? -1 : 1;
  });
};